import React, { useEffect, useState } from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import { v4 as uuidv4 } from "uuid";
import HomePage from "./pages/HomePage";
import LibraryPage from "./pages/LibraryPage";
import CreateThreadPage from "./pages/CreateThreadPage";
import ChatPageWrapper from "./pages/ChatPage";
import StoryTreePage from "./pages/StoryTreePage";
import ChatRouter from "./pages/ChatRouter";
import { initAnonymousAuth } from "./config/firebase";
import HeaderNav from "./components/home/HeaderNav";
import Footer from "./components/home/Footer";
import Terms from "./components/home/Terms";
import PrivacyPolicy from "./components/home/PrivacyPolicy";
import Contact from "./components/home/Contact";
import About from "./components/home/About";
import "./App.css";
import BannerSlider from "./modules/amazonAffiliate/BannerSlider";

function App() {
  const [userId, setUserId] = useState("");

  useEffect(() => {
    initAnonymousAuth();
  }, []);

  useEffect(() => {
    let storedId = localStorage.getItem("userId");
    if (!storedId) {
      storedId = uuidv4();
      localStorage.setItem("userId", storedId);
    }
    setUserId(storedId);
  }, []);

  if (!userId) return null;

  return (
    <Router>
      <HeaderNav />
      <BannerSlider />

      <main style={{ paddingTop: "10px", paddingBottom: "10px" , paddingLeft: "10px" }}>
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/library" element={<LibraryPage userId={userId} />} />
          <Route
            path="/create"
            element={<CreateThreadPage userId={userId} />}
          />
          <Route
            path="/chat/:nodeId"
            element={<ChatRouter userId={userId} />}
          />
          <Route
            path="/chat/:nodeId"
            element={<ChatPageWrapper userId={userId} />}
          />
          <Route path="/storytree/:storyId" element={<StoryTreePage />} />
          <Route path="/terms" element={<Terms />} />
          <Route path="/privacy" element={<PrivacyPolicy />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/about" element={<About />} />
        </Routes>
      </main>
      <BannerSlider />
      <Footer />
    </Router>
  );
}

export default App;
